import { EntityState, createEntityAdapter } from '@reduxjs/toolkit'
import { LineItem } from '../../../models/line-item'

export type ReduxLineItem = EntityState<LineItem>

export const lineItemsAdapter = createEntityAdapter<LineItem>({
  selectId: lineItem => lineItem.localId,
})
